import { meta } from '@/helpers/constants/router';
import SettingsRoutes from '@/plugins/router/apps/children/settings';
import BillingRoutes from '@/plugins/router/apps/children/v2/billing';
import EcommerceRoutes from '@/plugins/router/apps/children/v2/ecommerce/index';
import InsuranceRoutes from '@/plugins/router/apps/children/v2/insurance/index';
import ShopifyRoutes from '@/plugins/router/apps/children/v2/shopify/index';
import SurveyRoutes from '@/plugins/router/apps/children/v2/survey/index';
import InquiryRoutes from '@/plugins/router/apps/children/v2/inquiry';
import B2bRoutes from '@/plugins/router/apps/children/v2/b2b/index';
import StoreManagementRoutes from '@/plugins/router/apps/children/v2/store_management';
import StoreManagerRoutes from '@/plugins/router/apps/children/v2/store_manager';
import MainDistributorRoutes from '@/plugins/router/apps/children/v2/main_distributor/index';
import DistributorRoutes from '@/plugins/router/apps/children/v2/distributor/index';
import TermsAndAgreementRoutes from '@/plugins/router/apps/children/v2/terms_and_agreement';
import AdsManagerRoutes from '@/plugins/router/apps/children/v2/ads_manager';
import MiniAppDiyRoutes from '@/plugins/router/apps/children/v2/diy/index';
import NetworkDistributorRoutes from '@/plugins/router/apps/children/v2/network_distributor/index';
import AffiliateRoutes from '@/plugins/router/apps/children/v2/affiliate/index';
import { Step } from '@/helpers/entities/enums/v2/Step';
// lazy load components
// https://router.vuejs.org/guide/advanced/lazy-loading.html
const AppsWrapper = () => import('@/views/apps/AppsWrapper.vue');
const UserWrapper = () => import('@/views/apps/UserWrapper.vue');
const Wrapper = () => import('@/views/Wrapper.vue');
const AppsDashboard = () => import('@/views/v2/apps/index.vue');
export default [
    {
        path: '/apps',
        component: Wrapper,
        meta,
        children: [
            {
                path: '/',
                name: 'apps-dashboard',
                component: AppsDashboard,
                meta: { title: 'My In-App Stores' },
            },
            {
                path: ':key/:appUUID',
                component: AppsWrapper,
                props: true,
                name: 'app-dashboard',
                children: [
                    {
                        path: 'inbox',
                        name: 'inbox',
                        meta: { title: 'Inbox' },
                        component: () => import('@/views/v2/ComingSoon.vue'),
                    },
                    ...SettingsRoutes,
                    ...BillingRoutes,
                    ...EcommerceRoutes,
                    ...InquiryRoutes,
                    ...SurveyRoutes,
                    ...ShopifyRoutes,
                    ...B2bRoutes,
                    ...StoreManagementRoutes,
                    ...StoreManagerRoutes,
                    ...InsuranceRoutes,
                    ...MainDistributorRoutes,
                    ...DistributorRoutes,
                    ...TermsAndAgreementRoutes,
                    ...AdsManagerRoutes,
                    ...MiniAppDiyRoutes,
                    ...AffiliateRoutes,
                ],
            },
        ],
    },
    {
        path: '/network-distributor',
        component: Wrapper,
        meta,
        children: [
            {
                path: ':resellerUuid',
                name: 'network-distributor-dashboard',
                meta: { title: 'Overview' },
                component: UserWrapper,
                children: [...NetworkDistributorRoutes],
            },
        ],
    },
    {
        path: '/affiliate',
        component: Wrapper,
        meta,
        children: [
            {
                path: ':resellerUuid',
                name: 'affiliate-manager',
                component: () => import('@/views/v2/AffiliateManager.vue'),
                meta: {
                    title: 'Affiliate Manager',
                },
                children: [
                    {
                        path: 'invites',
                        name: 'affiliate-invites',
                        component: () => import('@/components/v2/affiliate/AffiliateInvites.vue'),
                        meta: { title: 'Affiliate Invites' },
                    },
                    {
                        path: 'activated',
                        name: 'affiliate-activated-apps',
                        component: () => import('@/components/v2/affiliate/AffiliateActivatedApps.vue'),
                        meta: { title: 'Activated Apps' },
                    },
                    {
                        path: 'signups',
                        name: 'affiliate-signed-up-apps',
                        component: () => import('@/components/v2/affiliate/AffiliateSignedUpApps.vue'),
                        meta: { title: 'Signed Up Apps' },
                    },
                    {
                        path: 'payouts',
                        name: 'affiliate-payouts',
                        component: () => import('@/components/v2/affiliate/SalesPartnerPayout.vue'),
                        meta: { title: 'Sales Partner Payouts' },
                    },
                ],
            },
        ],
    },
    {
        path: '/profile',
        component: Wrapper,
        meta,
        redirect: { name: 'user-profile' },
        children: [
            {
                path: '/',
                props: true,
                name: 'user-profile',
                component: () => import('@/views/v2/UserProfile.vue'),
            },
            {
                path: 'update',
                props: true,
                name: 'profile-update',
                component: () => import('@/components/v2/AccountDetailForm.vue'),
            },
        ],
    },
    {
        path: '/affiliate-v2',
        component: Wrapper,
        meta,
        children: [
            {
                path: ':userUuid',
                name: 'affiliate-v2-sign-up',
                props: true,
                component: () => import('@/components/v2/user/AffiliateUserSignUp.vue'),
            },
            {
                path: 'diy/:appUuid',
                component: Wrapper,
                meta,
                children: [
                    {
                        path: 'step-redirecter',
                        name: 'affiliate-step-redirecter',
                        component: () => import('@/views/v2/diy/StepRedirecter.vue'),
                        props: true,
                        meta,
                    },
                    {
                        path: 'affiliate-your-facebook',
                        name: 'affiliate-your-facebook',
                        component: () => import('@/views/v2/PageActivation.vue'),
                        props: true,
                        meta: {
                            ...meta,
                            title: 'Connect your Facebook Page.',
                            subtitle: 'Connect your selected Facebook Page to create an In-App Store.',
                            step: Step.One,
                        },
                    },
                    {
                        path: 'product-marketplace',
                        name: 'affiliate-product-setup',
                        component: () => import('@/views/v2/your_store/ProductMarketPlace.vue'),
                        props: true,
                        meta: {
                            ...meta,
                            diy: true,
                            title: 'Product Marketplace',
                            subtitle: 'Select products to showcase here.',
                            step: Step.Two,
                        },
                    },
                    // this is for affiliate commission disbursement form
                    {
                        path: 'affiliate-commission-form',
                        name: 'affiliate-commission-form',
                        component: () => import('@/views/v2/AffiliateCommissionForm.vue'),
                        props: true,
                        meta: {
                            ...meta,
                            title: 'Affiliate Commission Disbursement',
                            subtitle: 'Fill up the form below for disbursements',
                            step: Step.Three,
                        },
                    },
                ],
            },
        ],
    },
];
